(ns app.front.view.system-of-units.toggle
  (:require [app.front.ui.content-switcher :as ui-cs]
            [core.domain.system-of-units :as sou]
            [core.front.config :as front-config]
            [core.front.event :refer [<sub >evt]]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::available-unit-systems
  :<- [::front-config/config]
  :-> :units)

(rf/reg-sub ::multiple-unit-systems?
  :<- [::available-unit-systems]
  #(> (count %) 1))

(rf/reg-sub ::default-system-of-units
  :<- [::available-unit-systems]
  :-> sou/default-system-of-units)

(rf/reg-event-db ::select-system-of-units
  (fn [db [_ selected]]
    (assoc db ::selected-system selected)))

(rf/reg-sub ::raw-selected-system-of-units
  :-> ::selected-system)

(rf/reg-sub ::selected-system-of-units
  :<- [::raw-selected-system-of-units]
  :<- [::default-system-of-units]
  (fn [[selected default] _]
    (or selected default)))

(defn unit-info-handler [system-of-units [_ unit]]
  (when unit
    (sou/unit-info unit system-of-units)))

(rf/reg-sub ::unit-data-in-selected-system
  :<- [::selected-system-of-units]
  unit-info-handler)

(rf/reg-sub ::unit-in-selected-system
  :<- [::selected-system-of-units]
  (fn [system [_ unit]]
    (when (and unit system)
      (-> sou/conversions unit system first))))

(rf/reg-sub ::unit-in-default-system
  :<- [::default-system-of-units]
  unit-info-handler)

(defn label-handler [unit-info _]
  (:label unit-info))

(rf/reg-sub ::label-in-selected-system
  (fn [[_ unit]]
    (rf/subscribe [::unit-data-in-selected-system unit]))
  label-handler)

(rf/reg-sub ::label-in-default-system
  (fn [[_ unit]]
    (rf/subscribe [::unit-in-default-system unit]))
  label-handler)

(defn convert-subscription-handler [system-of-units [_ unit value]]
  (if unit
    (sou/convert-value unit system-of-units value)
    value))

(rf/reg-sub ::value-in-selected-system
  :<- [::selected-system-of-units]
  convert-subscription-handler)

(rf/reg-sub ::value-in-default-system
  :<- [::default-system-of-units]
  convert-subscription-handler)


(rf/reg-sub ::is-default-system?
  :<- [::selected-system-of-units]
  :<- [::default-system-of-units]
  (fn [[sel default] _]
    (= sel default)))

(defn system-of-units-toggle []
  (let [tr               (<sub [:tr])
        systems-of-units (<sub [::available-unit-systems])]
    (when (< 1 (count systems-of-units))
      [:div.h-12.flex.items-center.justify-end.gap-2
       [:div.mx-2 (tr [:all-values-are-in])]
       [ui-cs/content-switcher
        {:items     systems-of-units
         :val->str  #(tr [%])
         :current   (<sub [::selected-system-of-units])
         :on-change #(>evt [::select-system-of-units %])}]])))
